module.exports = new __parcel__URL__("coins-flat-darkmode.46361372.svg").toString();